import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth, API } from "@/App";
import axios from "axios";

export default function UsageIndicator() {
  const { user } = useAuth();
  const [usage, setUsage] = useState(null);

  useEffect(() => {
    if (!user) return;
    const fetch = async () => {
      try {
        const { data } = await axios.get(`${API}/pricing/usage`, {
          withCredentials: true,
        });
        setUsage(data);
      } catch {
        // silently fail — indicator is non-critical
      }
    };
    fetch();
  }, [user]);

  if (!usage) return null;

  const isPro = usage.plan_tier === "pro";

  if (isPro) {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-gray-900 text-white text-xs font-medium">
        Pro
      </span>
    );
  }

  const pct = usage.meetings_limit > 0
    ? (usage.meetings_used / usage.meetings_limit) * 100
    : 0;
  const color =
    pct >= 100 ? "text-red-600 bg-red-50 border-red-200"
      : pct >= 70 ? "text-amber-600 bg-amber-50 border-amber-200"
        : "text-gray-600 bg-gray-50 border-gray-200";

  return (
    <Link
      to="/settings"
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border transition-colors hover:opacity-80 whitespace-nowrap ${color}`}
      title="View usage & billing"
    >
      <span>{usage.meetings_used}/{usage.meetings_limit} meetings</span>
    </Link>
  );
}
